import { SurveyOpinionTaskStatusEnum } from "./enums/SurveyOpinionTaskStatusEnum"

export class AvailableActions {
  actions: Action[]
  messages: MessageAction[]
}

export class Action {
  currentStatus: string
  nextStatus: SurveyOpinionTaskStatusEnum
  class: any
  title: string
  actionId: number
  apiName: string
}
export class MessageAction {
  message: string
  image: string
}
